export default __webpack_public_path__ + "static/media/use.04ca31de.svg";